import { createHttpClient } from "./http";

const api = createHttpClient("/api");

export function fetchCompany() {
  return api.get("/company");
}

export function fetchProjects(params) {
  return api.get("/projects", { params });
}

export function fetchProjectById(id) {
  return api.get(`/projects/${id}`);
}

export function fetchNews(params) {
  return api.get("/news", { params });
}

export function fetchNewsById(id) {
  return api.get(`/news/${id}`);
}

export function fetchJobs(params) {
  return api.get("/jobs", { params });
}

export function fetchJobById(id) {
  return api.get(`/jobs/${id}`);
}

export function submitMessage(data) {
  return api.post("/messages", data);
}

export function recordVisit(path) {
  return api.post("/visitor", { path }).catch(() => {});
}
